<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.46579 22.5301H21.1165C23.8616 22.5316 26.1444 20.4181 26.3542 17.6811C26.564 14.944 24.6299 12.5074 21.9167 12.0905C21.4631 10.2917 20.4299 8.69235 18.9765 7.53954C17.4964 6.36064 15.6583 5.72203 13.7661 5.72919C10.7316 5.73293 7.93381 7.36931 6.44303 10.0124C3.20416 10.5433 0.915363 13.4717 1.18263 16.7429C1.4499 20.014 4.1837 22.5321 7.46579 22.5301ZM10.1372 14.7165L13.7506 18.3299L17.364 14.7165C17.5805 14.4999 17.4272 14.1297 17.1209 14.1297H15.2732V12.1253C15.2732 11.4925 14.7601 10.9795 14.1273 10.9795H13.3738C12.741 10.9795 12.228 11.4925 12.228 12.1253V14.1297H10.3802C10.074 14.1297 9.92062 14.4999 10.1372 14.7165Z"
            fill="#7A7A7A" />
    </svg>
</template>

<script>
export default {
    name: 'DownloadIconDisabled'
}
</script>